module.exports = __webpack_public_path__ + "img/logo_horizontal.888af7e.png";